import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    backgroundColor: "#454C96",
    color: "#FFFFFF",
    borderRadius: "8px",
    padding: "12px 40px",
    fontSize: "16px",
    fontWeight: 500,
    width: "100%",
    maxWidth: "350px",
    "&:hover": {
      backgroundColor: "#454C96",
    },
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  submitWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  "@media (max-width: 430px)": {
    submitButton: {
      maxWidth: "100%",
    },
  },
}));

interface SubmitButtonProps {
  className?: string;
  wrapperClassName?: string;
  onSubmit?: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  className,
  wrapperClassName,
  onSubmit,
}) => {
  const classes = useStyles();

  const handleClick = () => {
    if (onSubmit) {
      onSubmit();
    }

    // Give time for form validation to complete
    setTimeout(() => {
      const errorElement = document.querySelector(
        '[aria-invalid="true"]'
      ) as HTMLElement;
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }
    }, 100);
  };

  return (
    <div className={`${classes.submitWrapper} ${wrapperClassName || ""}`}>
      <Button
        type="submit"
        variant="contained"
        className={`${classes.submitButton} ${className || ""}`}
        onClick={handleClick}
      >
        <CheckOutlinedIcon style={{ marginRight: "20px" }} />
        提交
      </Button>
    </div>
  );
};

export default SubmitButton;
